import $ from "jquery/dist/jquery";
import '../../scss/static/02_fuckeu.scss';

$(() => {
  $('#fuckeu-ok, .cookies-banner-ok').on("click", (e) => {
      e.preventDefault();
      $.setCookie('cookies-ok', 'ok', 365 * 5);
      $('#fuckeu, .cookies-banner').fadeOut();
      return false;
  });
});
